export const sortedArray = array => {
  return array.sort((a, b) => {
    return a.index - b.index;
  });
};
export const formatDate = date => {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
};
export const parseQueryResults = apiResponseData => {
  let queryResults = {
    data: [],
    totalCount: 0,
    totalPages: 0
  };

  if (Array.isArray(apiResponseData)) {
    queryResults.data = apiResponseData[0].data.queryData && apiResponseData[0].data.queryData.length > 0 ? apiResponseData[0].data.queryData : [];
    queryResults.totalCount = apiResponseData[0].headers.totalcount;
    queryResults.totalPages = apiResponseData[0].headers.totalpages;
  } else {
    queryResults.data = apiResponseData[0].data.queryData && apiResponseData[0].data.queryData.length > 0 ? apiResponseData[0].data.queryData : [];
    queryResults.totalCount = apiResponseData[0].headers.totalcount;
    queryResults.totalPages = apiResponseData[0].headers.totalpages;
  }

  return queryResults;
};
export const parseChipArray = (selectedChipArray, operationsNamesArray, userAccountOperations) => {
  let parsedChipArray = [];
  let operationsArr = operationsNamesArray.concat(userAccountOperations);

  for (let tagItem of selectedChipArray) {
    let selectedOpr = '';

    for (let oprationItem of operationsArr) {
      if (tagItem.indexOf(' contains ') > -1) {
        selectedOpr = 'contains';
        break;
      } else if (tagItem.indexOf(' startsWith ') > -1) {
        selectedOpr = 'startsWith';
        break;
      } else if (tagItem.indexOf(' endsWith ') > -1) {
        selectedOpr = 'endsWith';
        break;
      } else if (tagItem.indexOf(' since ') > -1) {
        selectedOpr = 'since';
        break;
      } else if (tagItem.indexOf(' before ') > -1) {
        selectedOpr = 'before';
        break;
      } else if (tagItem.indexOf(' on ') > -1) {
        selectedOpr = 'on';
        break;
      } else if (tagItem.indexOf(oprationItem) > -1) {
        selectedOpr = oprationItem;
        break;
      }
    }

    let tagStringArray = [];

    if (tagItem.indexOf(selectedOpr) > -1) {
      tagStringArray = tagItem.split(' ' + selectedOpr + ' ');
    }

    let existIndex = parsedChipArray.findIndex(el => el.entityName === tagStringArray[0] && el.entityOpr === selectedOpr);

    if (existIndex > -1 && selectedOpr === 'is') {
      // if same key exists, then update entity values with comma seperated
      if (tagStringArray[0] === 'Risk Score') {
        parsedChipArray[existIndex].entityValue = tagStringArray[1];
      } else {
        parsedChipArray[existIndex].entityValue += ', ' + tagStringArray[1];
      }
    } else if (existIndex > -1) {
      parsedChipArray[existIndex].entityValue += ', ' + tagStringArray[1];
    } else {
      let obj = {};

      if (tagStringArray.length == 2) {
        obj['entityName'] = tagStringArray[0];
        obj['entityValue'] = tagStringArray[1];
        obj['entityOpr'] = selectedOpr;
      } else if (tagStringArray) {
        obj['entityName'] = tagItem;
        obj['entityValue'] = '';
        obj['entityOpr'] = '';
      }

      parsedChipArray.push(obj);
    }
  }

  return parsedChipArray;
};